import { useEffect } from "react";
import { cmsColSpanClass } from "@/components/organisms/CmsForm/cmsColSpan";
import type { CmsColSpan } from "@/components/organisms/CmsForm/cmsColSpan";

interface CmsPageErrorProps {
  error?: string | null;
  colSpan?: CmsColSpan;
}

/**
 * Renders a CMS page-level error and scrolls to top when it appears.
 */
export function CmsPageError({ error, colSpan }: CmsPageErrorProps) {
  useEffect(() => {
    if (error) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [error]);

  if (!error) return null;

  return (
    <p
      className={["cms-page__error", cmsColSpanClass(colSpan)]
        .filter(Boolean)
        .join(" ")}
    >
      {error}
    </p>
  );
}
